import { render, staticRenderFns } from "./removeStopSellingTask.vue?vue&type=template&id=58a49c07&scoped=true"
import script from "./removeStopSellingTask.vue?vue&type=script&lang=js"
export * from "./removeStopSellingTask.vue?vue&type=script&lang=js"
import style0 from "./removeStopSellingTask.vue?vue&type=style&index=0&id=58a49c07&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58a49c07",
  null
  
)

export default component.exports